<template>
  <transition name="modal-backdrop-transition" appear>
    <div @click="dismiss($event)" ref="backdrop" class="o-backdrop">
      <div class="modal">
        <div class="customer-type-chooser">
          <header class="customer-type-chooser__header">
            <h1 class="customer-type-chooser__title">Wen möchten Sie beschenken?</h1>
            <p class="customer-type-chooser__description">Für das passende Geschenk wählen Sie bitte Ihren Anwendungsfall aus.</p>
          </header>

          <content class="customer-type-chooser__content">
            <!-- <div class="customer-type-chooser__present">
              <img src="https://componata.de/img/box-packaging-0@1x.03493602.png" alt="Präsent" class="customer-type-chooser__present-photo">
            </div> -->

            <div class="customer-type-chooser__duplex">
              <!-- b2c -->
              <div
                @click="switchCustomerType('b2c'); $root.$emit('hideCustomerTypeModal'); trackEvent('setB2c', { source: 'Modal', element: 'Button' });"
                class="customer-type-chooser__type --is-b2c"
              >
                <div class="customer-type-chooser__type-wrapper">
                  <ul class="customer-type-chooser__features">
                    <li>Familienangehörige</li>
                    <li>Freunde</li>
                    <li>Partner</li>
                  </ul>

                  <Button @click="switchCustomerType('b2c'); $root.$emit('hideCustomerTypeModal'); trackEvent('setB2c', { source: 'Modal', element: 'Button' });" appearance="primary" size="large" class="customer-type-chooser__cta">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><g><g><path d="M15.5,15.9c-.38-2.76-3.52-2.52-3.95-.18-.3,1.7,1.88,4.34,2.72,5.29a.48.48,0,0,0,.6.1c1.12-.59,4.08-2.3,4.39-4C19.68,14.77,16.82,13.44,15.5,15.9Z" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M13.62,13.9A3.58,3.58,0,0,0,13.69,12c-.84-2.89-4.95-2.68-4.78,1.08C7,9.84,3.46,11.87,4.3,14.76c.62,2.13,4.83,3.91,6.07,4.39a.47.47,0,0,0,.56-.17c.22-.29.58-.8,1-1.42" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M.75.75A68.6,68.6,0,0,0,23.25,3" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><g><line x1="3" y1="21.75" x2="6" y2="21.75" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><line x1="4.5" y1="20.25" x2="4.5" y2="23.25" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line></g><g><line x1="20.25" y1="21.75" x2="23.25" y2="21.75" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><line x1="21.75" y1="20.25" x2="21.75" y2="23.25" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line></g><g><line x1="19.5" y1="11.25" x2="22.5" y2="11.25" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><line x1="21" y1="9.75" x2="21" y2="12.75" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line></g><g><line x1="0.75" y1="9" x2="3.75" y2="9" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><line x1="2.25" y1="7.5" x2="2.25" y2="10.5" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line></g></g><path d="M2.43,1.16,4.3,5a.77.77,0,0,0,.51.4.75.75,0,0,0,.63-.14L9,2.44" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M9,2.44l2.42,4.1a.75.75,0,0,0,.57.37.78.78,0,0,0,.64-.26l3.08-3.54" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M15.73,3.11,19,6.79a.72.72,0,0,0,.63.25.75.75,0,0,0,.58-.36l2.18-3.62" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path></g></g></svg>

                    <div>
                      <b>Privates Umfeld</b>
                      <small>Privatkunden</small>
                    </div>
                  </Button>
                </div>
              </div>
              <!-- /b2c -->

              <!-- b2b -->
              <div
                @click="switchCustomerType('b2b'); $root.$emit('hideCustomerTypeModal'); trackEvent('setB2b', { source: 'Modal', element: 'Button' });"
                class="customer-type-chooser__type --is-b2b"
              >
                <div class="customer-type-chooser__type-wrapper">
                  <ul class="customer-type-chooser__features">
                    <li>Mitarbeiter</li>
                    <li>Kunden</li>
                    <li>Geschäftspartner</li>
                    <li>Arbeitskollegen</li>
                  </ul>

                  <Button @click="switchCustomerType('b2b'); $root.$emit('hideCustomerTypeModal'); trackEvent('setB2b', { source: 'Modal', element: 'Button' });" appearance="tertiary" size="large" class="customer-type-chooser__cta">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><g><rect x="0.75" y="6.75" width="22.5" height="15" rx="1.5" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></rect><path d="M16.5,6.75a4.5,4.5,0,0,0-9,0" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><line x1="0.75" y1="12.75" x2="9.75" y2="12.75" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><line x1="14.25" y1="12.75" x2="23.25" y2="12.75" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><path d="M9.75,13.75a2.25,2.25,0,0,0,4.5,0v-1.2a2.25,2.25,0,0,0-4.5,0Z" style="fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path></g></g></svg>

                    <div>
                      <b>Geschäftliches Umfeld</b>
                      <small>Firmenkunden</small>
                    </div>
                  </Button>
                </div>
              </div>
              <!-- /b2b -->
            </div>

            <div v-if="flashMessage" class="customer-type-chooser__flash">Bitte wählen Sie Ihren Anwendungsfall aus</div>
          </content>

          <button
            @click="switchCustomerType('b2c'); $root.$emit('hideCustomerTypeModal'); trackEvent('setB2c', { source: 'Modal', element: 'Close' });"
            class="customer-type-chooser__close"
          >
            <i class="icon icon-times"></i>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import Button from '@/components/Common/Button';

export default {
  name: 'CustomerTypeModal',
  mixins: [logicMixin, helperMixin],
  components: {
    Button,
    // Popper
  },
  data () {
    return {
      flashMessage: false
    };
  },
  methods: {
    submit (customerType) {
      this.$store.commit('setCustomerType', customerType);
      // this.$root.$emit('closeCustomerTypeModal');
    },

    dismiss (e) {
      if (e.target === this.$refs.backdrop) {
        this.flashMessage = true;

        setTimeout(() => {
          this.flashMessage = false;
        }, 1500);
      }
    }
  },
  mounted () {
    document.querySelector('body').style.setProperty('overflow', 'hidden');
  },
  destroyed () {
    document.querySelector('body').style.removeProperty('overflow');
  }
};
</script>

<style lang="scss" scoped>
/**
 * CustomerTypeModal
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Modal for setting the customer type (B2C or B2B)
 * @since 2022-02-11
**/

$component: 'customer-type-chooser';

.#{$component} {
  --side-min-width: 22rem;
  --present-height: 150px;

  overflow: hidden;
  border-radius: $border-radius-lg;
  @include font-size($font-size-lg);
  will-change: transform;

  &__header {
    @include padding(map-get($spacers, 6));
    text-align: center;
  }

  &__title {
    @include font-size($h1-font-size);
  }

  &__description {
    margin: 0;
    @include font-size($font-size-lg);
    color: $ink-lightest;
  }

  &__content {
    display: block;
    position: relative;
    border-radius: $border-radius-lg;
    background: linear-gradient(to bottom, white, rgba($ink, 0.2) 50%);

    @include hover () {
      .#{$component}__type-wrapper {
        opacity: 0.5;
      }
    }
  }

  &__present {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    height: var(--present-height);
    margin-top: -80px;
    background: url('~@/assets/images/stars.svg') center 30% no-repeat;
    background-size: 60%;
    pointer-events: none;
  }

  &__present-photo {
    height: 100%;
    object-fit: contain;
  }

  &__duplex {
    display: flex;
    align-items: stretch;
    height: calc(var(--present-height) * 1.4);
  }

  &__type {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: var(--side-min-width);
    @include padding(0 map-get($spacers, 5) map-get($spacers, 4));
    cursor: pointer;

    @include hover () {
      .#{$component} {
        &__type-wrapper {
          opacity: 1;
        }

        &__features {
          transform: translateY(-10px);
        }

        &__cta {
          transform: perspective(1px) scale(1.1);
          -webkit-transform: perspective(1px) scale(1.1);
        }
      }
    }
  }

  &__type-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    transition: opacity 0.2s ease-in-out;
  }

  &__features {
    @include unlist;
    @include margin-bottom(map-get($spacers, 4));
    color: $ink-lighter;
    transition: transform 0.2s ease-out;

    > li {
      display: flex;
      align-items: center;

      &:before {
        content: '\e912';
        display: block;
        color: $ink-lighter;
        font-family: 'icomoon';
        @include font-size($font-size-lg * 1.1);
        @include margin-right(map-get($spacers, 2));
      }
    }
  }

  &__cta {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    text-align: left;
    transition: transform 0.2s ease;

    svg {
      flex-basis: 36px;
      width: unset !important;
      height: unset !important;
      margin-left: unset;
      @include margin-right(map-get($spacers, 3));
    }

    > div {
      display: flex;
      flex-direction: column-reverse;
      line-height: 1;

      > small {
        @include margin-bottom(map-get($spacers, 1));
        opacity: 0.8;
      }
    }
  }

  &__flash {
    position: absolute;
    top: 18%;
    left: 20%;
    right: 20%;
    margin: 0 auto;
    @include padding(map-get($spacers, 1));
    border-radius: $border-radius;
    background-color: $yellow;
    text-align: center;
  }

  &__close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    background: none;

    .icon {
      color: $sky;
      @include font-size($font-size-base * 1.8);
    }
  }

  // B2C
  .--is-b2c:not(.btn) {
    margin-right: 0.5px;
    background: linear-gradient(to top, #F1FFE3, 60%, #fff 100%);

    @include hover () {
      background: linear-gradient(to top, darken(#F1FFE3, 2%) 60%, #fff 100%);
    }

    .#{$component} {
      &__cta svg {
        color: white;
      }

      &__features > li:before {
        color: $green;
      }
    }
  }

  // B2B
  .--is-b2b:not(.btn) {
    margin-left: 0.5px;
    background: linear-gradient(to top, #E2F3FF 60%, #fff 100%);

    @include hover () {
      background: linear-gradient(to top, darken(#E2F3FF, 2%) 60%, #fff 100%);
      background-position: right center;
    }

    .#{$component} {
      &__cta svg {
        color: white;
      }

      &__features > li:before {
        color: $blue;
      }
    }
  }

  // Transition
  &__question-transition {
    &-enter-active,
    &-leave-active {
      max-height: 100px;
      transition: opacity 0.2s, max-height 0.2s;
      opacity: 1;
      will-change: max-height;
    }

    &-enter,
    &-leave-to {
      max-height: 0;
      opacity: 0;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    --present-height: 150px;

    &__description {
      width: 80%;
      margin: 0 auto;
    }

    &__present {
      margin-top: -70px;
    }

    &__features {
      display: none;
    }

    &__cta small {
      display: none;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    --side-min-width: 10rem;
    --present-height: 180px;

    &__description {
      width: 100%;
    }

    &__content {
      position: static;
      background: none;
    }

    &__duplex {
      flex-direction: column;
    }

    &__type {
      width: 100%;
      @include padding-top(map-get($spacers, 4));
    }

    &__present {
      position: unset;
      margin-top: -40px;
    }

    &__duplex {
      height: auto;
    }

    &__cta small {
      display: unset;
    }

    &.--is-alt-version {
      .#{$component} {
        &__cta {
          margin: 0;
          justify-content: center;

          &:first-child {
            @include margin-bottom(map-get($spacers, 2));
          }
        }
      }
    }
  }
}
</style>
